import React, { Fragment, useRef } from 'react';
import api from 'constants/api';
import IconHeader from '../../IconHeader';
import AxiosPageReadyWrapper, {
  AxiosPageReadyContext,
} from '../../AxiosPageReadyWrapper';
import CouponItem from '../CouponItem';

const CouponList = ({ limit = 0 }) => {
  const getCouponList = (coupons) => {
    if (limit > 0) {
      return coupons.slice(0, limit);
    }
    return coupons;
  };

  const viewMore = () => {
    window.location.assign('/coupons');
  };

  const couponsPageReady = useRef();

  return (
    <div className="coupons__section">
      <div className="coupons__header">
        <IconHeader title="Coupons" svgName="my_coupon" />
      </div>
      <div className="coupons__list">
        <AxiosPageReadyWrapper ref={couponsPageReady} url={api.data.COUPONS}>
          <AxiosPageReadyContext.Consumer>
            {({ data: coupon = [] }) => {
              const couponList = getCouponList(coupon);
              return (
                <Fragment>
                  {couponList.length > 0 ? (
                    couponList.map((data, key) => {
                      return <CouponItem key={key} index={key} data={data} />;
                    })
                  ) : (
                    <div className="coupons__empty">
                      <div className="coupons__empty-content">
                        <div className="coupons--empty-message">
                          Currently you have no saved coupons with Luxity.
                        </div>
                      </div>
                    </div>
                  )}
                  {limit > 0 && coupon.length > limit && (
                    <div className="coupons__view-more">
                      <button
                        type="button"
                        className="btn--primary coupons__view-more-btn"
                        onClick={viewMore}>
                        view more
                      </button>
                    </div>
                  )}
                </Fragment>
              );
            }}
          </AxiosPageReadyContext.Consumer>
        </AxiosPageReadyWrapper>
      </div>
    </div>
  );
};

export default CouponList;
